import nonEmptyString from './nonEmptyStringValidator.js'

export default function (input) {
    const regex = /^\d{4}$/
    return nonEmptyString(input) && !!input.match(regex)
}
